import React from 'react'

const itemTotal = tickets => {
  if (tickets) {
    return tickets.reduce(
      (total, myitem) => total + parseInt(myitem.quantity, 10),
      0
    )
  }
}

function GroupedEventItem({ date, items }) {
  return (
    <div className="mt-32 text-depths">
      <p className="cta-label">{date}</p>
      {items.map(item => {
        return (
          <p
            key={item.id}
            className="mt-8 mb-0 font-light leading-normal text-16"
          >
            {item.name} x {itemTotal(item.tickets)}
          </p>
        )
      })}
    </div>
  )
}

export default GroupedEventItem
